import Events from "ampersand-events";
import assign from "lodash/assign";

export class InfiniteApi {
    declare on: (eventName: string, func: any) => void;
    declare off: (eventName: string, func: any) => void;
    declare trigger: (eventName: string, params: { [key: string]: any }) => void;
}

assign(InfiniteApi.prototype, Events);
